import React, { PropsWithChildren } from 'react';
import {
  Button,
  Form,
  FormControlLabelProps,
  Input,
  InputProps,
  SelectPicker,
  SelectPickerProps,
} from 'rsuite';

interface FormProps {
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
}

function CustomPaymentFormElements({
  children,
  onSubmit,
}: PropsWithChildren<FormProps>) {
  return (
    <form
      style={{
        marginTop: '24px',
        width: '450px',
      }}
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
}
const CustomFormGroup = ({ children }: PropsWithChildren) => (
  <Form.Group
    style={{
      display: 'flex',
      flexDirection: 'column',
      margin: '0.5rem 0',
      width: '100%',
    }}
  >
    {children}
  </Form.Group>
);

const FormLabel = ({
  children,
  ...rest
}: PropsWithChildren<FormControlLabelProps>) => (
  <Form.ControlLabel {...rest}>{children}</Form.ControlLabel>
);

const FormError = ({ error }: { error?: unknown }) => {
  function renderError(error: unknown): React.ReactNode {
    if (!error) return null;
    if (typeof error === 'string') return error;
    if (Array.isArray(error)) return error.map(renderError).join(', ');
    if (typeof error === 'object') return JSON.stringify(error);
    return String(error);
  }
  return (
    <div
      style={{
        color: '#991111',
        fontSize: '0.75rem',
      }}
    >
      {renderError(error)}
    </div>
  );
};

const FormInput = (props: InputProps) => {
  return (
    <Input
      as="input"
      {...props}
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: '0.25rem 0',
      }}
    />
  );
};

const PaymentButton = ({
  children,
  loading,
}: PropsWithChildren<{ loading: boolean }>) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-start',
      width: '50%',
      marginTop: '1rem',
    }}
  >
    <Button
      appearance="primary"
      id="type-button"
      loading={loading}
      type="submit"
      style={{ width: '100%' }}
    >
      {children}
    </Button>
  </div>
);

function Select<T>(props: SelectPickerProps<T>) {
  return (
    <SelectPicker
      {...props}
      style={{ flexGrow: 1, width: '100%', paddingTop: '4px' }}
    />
  );
}

const FieldContainer = ({
  children,
  id,
}: PropsWithChildren<{ id: string }>) => (
  <div
    id={id}
    style={{
      borderRadius: 0,
      border: '1px solid #e5e5e5',
      boxSizing: 'border-box',
      height: '36px',
      padding: '7px 11px',
    }}
  >
    {children}
  </div>
);

CustomPaymentFormElements.Error = FormError;
CustomPaymentFormElements.FieldContainer = FieldContainer;
CustomPaymentFormElements.FormGroup = CustomFormGroup;
CustomPaymentFormElements.Input = FormInput;
CustomPaymentFormElements.Label = FormLabel;
CustomPaymentFormElements.PaymentButton = PaymentButton;
CustomPaymentFormElements.Select = Select;

export default CustomPaymentFormElements;
